/*
 * @Description: 项目备忘
 * @Autor: pangting
 * @Date: 2026-09-30 14:07:00
 * @LastEditors: pangting
 * @LastEditTime: 2026-09-30 14:09:57
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
export class WorkProjectMemorandumApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'work-projectmemorandum'
  }



}
